import SS_FOG from "@assets/images/login/SS_FOG.png";
import ButtonVariants from "@core-components/button/ButtonVariants";
import { Group, Image, Modal, Paper } from "@mantine/core";
import { useFocusTrap } from "@mantine/hooks";
import AuthPage from "@modules/login/AuthPage";
import useLoginModalStore from "@store/loginModal.store";
import { IconX } from "@tabler/icons-react";

const LoginModal: React.FC = () => {
  const { isOpened, close } = useLoginModalStore();
  const focusTrapRef = useFocusTrap();

  return (
    <Modal
      centered
      size="auto"
      withCloseButton={false}
      classNames={{
        body: "p-0 max-h-[500px] h-[50vh] xs:h-[40vh] sm:h-[50vh] relative",
        content:
          "rounded-[10px] bg-primary-background select-none rounded-lg border-[0.5px] border-secret-purple-default",
        header: "bg-primary-background shadow-lg",
      }}
      closeButtonProps={{ className: "default-icon" }}
      opened={isOpened}
      onClose={close}
    >
      <ButtonVariants.ActionIcon
        onClick={close}
        className={"default-icon absolute top-3 left-3"}
      >
        <IconX />
      </ButtonVariants.ActionIcon>
      <Group
        className="h-full items-stretch overflow-y-auto overflow-x-hidden sm:items-stretch"
        ref={focusTrapRef}
      >
        <Paper
          classNames={{
            root: "space-y-8 w-[350px] m-[40px] sm:m-[70px] bg-primary-background relative z-0",
          }}
          radius={"none"}
        >
          <AuthPage />
        </Paper>
        <div className="z-10 hidden h-full max-w-[500px] lg:block">
          <Image src={SS_FOG} className="h-full" />
        </div>
      </Group>
    </Modal>
  );
};

export default LoginModal;
